import { registerPlugin } from '@capacitor/core';
const ScreenReader = registerPlugin('ScreenReader', {
    web: () => import('./web').then((m) => new m.ScreenReaderWeb()),
});
export * from './definitions';
export { ScreenReader };
//# sourceMappingURL=index.js.map